<!-- Runmode:A3/A3O用のコンポーネント -->
<template>
  <div class="a3">
    <PinchInActStore/>
    <div class="page-content">
      <div id="eleCorrect" class="correct"></div>
      <div class="inner" :class="cssLayoutID">
        <div class="toparea-image">
          <div class="img-wrapper"
               @touchstart="onTouchStart()"
               @touchend="onTouchEnd()"
               @touchmove="onTouchEnd()"
               @mousedown="$emit('hintMouseDown', $event)"
               @mouseup="$emit('hintMouseUp', $event)"
               @mousemove="$emit('hintMouseMove', $event)"
               ondragstart="return false">
               <img v-show="showImage" :src="qImage">
          </div>
        </div>

        <CommonAct :pathstep="pathstep" :activeType="activeType" :actChoice="true" :horizontalRow="true"
                   :answerAct="currentData" :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent"
                   :changeEndAct="changeEndAct" :scriptSystems="scriptSystems" :isCompleteParent="isCompleteParent"
                   :isActivesParent="isActivesParent"  :changeActives="changeActives" :needsSwiper="false" :isScrollIconVisible="isScrollIconVisible"
                   @actCorrect="recieveActCorrect" @actInCorrect="recieveActInCorrect" @audioPause="audioPause()"
                   @updateLearnedGroup="$emit('updateLearnedGroup')"/>

      <!-- /.inner -->
      </div>
    <!-- /.page-content -->
    </div>
  <!-- /.a3_01 -->
  </div>
</template>

<script>
// 共通処理
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

//コンポーネント
import CommonAct from "./CommonAct";
import PinchInActStore from "./PinchInActStore";

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// Vuexで状態管理
const store = new Vuex.Store({
  state: {
    questionState: "start"
  },
  mutations: {
    changeQuestionState(state, payload) {
      state.questionState = payload.val;
    }
  }
});

export default {
  name: "A3",
  props: {
    pathstep: Object,
    productLanguage: String,
    scriptSystems: Object,
    isScrollIconVisible: Boolean
  },
  mixins: [
    common,
    runmode,
    audio,
    constants
  ],
  data() {
    return {
      qImage: "",
      // 出題対象のactData
      currentData: null,
      // 正解／不正解を判断するフラグ（storeコミット用）
      isActState: true,
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // 適用するレイアウトクラス
      activeType: "active-type1",
      // Actのテキスト表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // Actの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // 出題用画像を表示するかを判断するフラグ
      showImage: false,
      // 監視用のステータス(EndAct)
      changeEndAct: false,
      // タッチイベント長押しタイマー
      touchTimer: null,
      // 正解済みのActかを判断するBoolean配列
      isCompleteParent: [],
      // givenの問題をまとめたactの配列
      givenActs: [],
      // activeクラスを適用するかを判断するBoolean配列
      isActivesParent: [],
      // 監視用のステータス(Active)
      changeActives: false
    };
  },
  computed: {
    questionStatus: function() {
      return store.state.questionState;
    }
  },
  components: {
    CommonAct,
    PinchInActStore
  },
  created: function() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  beforeDestroy: function() {
    var i = 0;
    while (i < this.pathstep.acts.length) {
      this.pathstep.acts[i].correct = false;
      i++;
    }
  },
  methods: {
    /**
    /* 初期化処理
     */
    init: function() {
      this.log("A3 start init");

      // ACTの取得
      this.pathstep.acts = this.getShuffleItems();

      // 各Actのテキスト／音声再生アイコンを表示するかを判定する
      this.initShowActText();
      this.initShowActVoice();
      this.initShowActImage();
    },
    /**
    /* 出題問題を取得する
     */
    challengeQuestion: function() {
      this.log("A3 start challengeQuestion");

      const self = this;

      this.isActivesParent = [];
      this.changeActives = true;
      this.enabledIconVoice();
      var commonAct = this.$children.find(function(child) {
        return child.$options.name == constants.VUE_NAME_COMMONACT;
      });
      if (commonAct) {
        commonAct.isSelects = [];
      }

      this.currentData = this.getQuestionRandom();

      if (this.currentData == null) {
        // 親(Runmode.Vue)に通知する
        self.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
        return;
      }

      this.qImage = this.currentData.image;
      if (!this.dispAllAnswerStatus) {
        this.showImage = true;
      }
    },
    /**
     * givenの問題取得
     */
    givenQuestions: function() {
      this.log("A3 start givenQuestions");

      var acts = this.pathstep.acts;

      for (var i = 0; i < acts.length; i++) {
        if (this.isGiven(acts[i])) {
          this.givenActs.push({ act: acts[i], index: i });
        }
      }

      this.givenPlaySounds();
    },
    /**
     * given問題の再生処理
     */
    givenPlaySounds: function() {
      this.log("A3 start givenPlaySounds");

      const self = this;
      var acts = this.pathstep.acts;

      if (this.givenActs.length == 0) {
        // 再生するgivenのActがない場合は、challenge問題を出題する
        for (var i = 0; i < acts.length; i++) {
          if (this.isChallenge(acts[i])) {
            this.challengeQuestion();
            return;
          }
        }
        return;
      }

      this.isActivesParent = [];
      this.isActivesParent[this.givenActs[0].index] = true;
      this.changeActives = true;

      this.audioPlay(this.givenActs[0].act.sounds[0]);
      var endedEvent = function() {
        $(self.myAudio).off("ended error", endedEvent);
        self.changeActives = false;
        self.givenActs.shift();

        self.setInterval(constants.QUESTION_INTERVAL).then(function() {
          self.givenPlaySounds();
        });
      };
      $(this.myAudio).on("ended error", endedEvent);
    },
    /**
     * Actの正解通知を受け取る
     */
    recieveActCorrect: function(showTexts, showVoices, index) {
      this.log("A3 start recieveActCorrect");

      const self = this;

      this.pathstep.acts[index].correct = true;
      this.setActState(this.isActState);
      this.isActState = true;
      this.enabledIconVoice();
      // スコア表示中・全解答表示中は次の問題出題しない
      if (this.lessonState == storeConstants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      if (this.isAllCorrect()) {
        this.showImage = false;
        this.changeEndAct = true;

        // 親（Runmode.Vue）に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, constants.ALLCORRECT_INTERVAL);
      } else {
        this.pathstep.acts = this.getShuffleItems();
        this.initShowActVoice();
        this.initShowActImage();
        this.challengeQuestion();
      }
    },
    /**
     * Actの不正解通知を受け取る
     */
    recieveActInCorrect: function() {
      this.log("A3 start recieveActInCorrect");

      this.isActState = false;
      this.enabledIconVoice();
    },
    /**
     * 全解答表示時の処理
     */
    showAllAnswer: function() {
      this.log("A3 start showAllAnswer");

      // 出題画像を非表示に
      this.showImage = false;
    },
    /**
     * 全解答解除時の処理
     */
    hideAllAnswer: function() {
      this.log("A3 start hideAllAnswer");

      // 全解答表示前の状態に戻す
      this.showImage = true;
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function() {
      this.log("A3 start initShowActText");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        this.isShowTextsParent[i] = true;
        i++;
      }
    },

    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function() {
      this.log("A3 start initShowActVoice");

      var i = 0;
      while (i < this.pathstep.acts.length) {
        switch (this.pathstep.mode) {
          case constants.RUNMODE_A3:
          case constants.RUNMODE_A3O:
            this.isShowVoicesParent[i] = true;
            break;
          case constants.RUNMODE_C3:
          case constants.RUNMODE_C3O:
            for (var i = 0; i < this.pathstep.acts.length; i++) {
              if (this.isChallenge(this.pathstep.acts[i])) {
                this.isShowVoicesParent[i] = false;
              } else {
                this.isShowVoicesParent[i] = true;
              }
            }
            break;
          default:
            break;
        }
        i++;
      }
    },
    /**
     * 初期表示時に各ACTの画像を表示するかを判定する
     */
    initShowActImage: function() {
      this.log("A3 start initShowActImage");

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          this.isCompleteParent[i] = false;
        } else {
          this.isCompleteParent[i] = true;
        }
      }
    },
    /**
     * 長押しイベント開始
     */
    onTouchStart: function() {
      var self = this;
      this.touchTimer = setTimeout(function() {
        var pinchInActParams = {
          isShowPinchIn: true,
          pinchInAct: self.currentData,
          pinchTileText: "",
          pinchInShowAnswerText: "",
          pinchInShowVoice: false,
          pinchInShowTextAct: false,
          pinchInDispText: "",
          pinchInActIndex: 0,
          isCompletes: false,
          horizontalRow: false
        };

        self.$store.dispatch("showPinchIn", pinchInActParams);
      }, constants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > div > div > .item:first").clone();
        clones.textArea = clones.card.children("div").children(".item-inner").children(".word");
        clones.textArea.empty();
        clones.textArea.append("<span/>");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > div > div");
      };

      // 対象テキストを取得
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      const textArea = $(".card-inner .item > div > .item-inner .word");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
    }
  },
  mounted: function() {
    if (this.lessonState == storeConstants.LESSON_STATE_START) {
      this.givenQuestions();
    }
    // 自動調整初期処理
    this.initAutoAdjust([".page-content"], [".cards-container"]);
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("A3 watch dispAllAnswerStatus");
      const self = this;

      if (this.dispAllAnswerStatus) {
        this.audioPause();
        this.showImage = false;
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else {
        if (this.isAllCorrect()) {
          // 親（Runmode.Vue）に通知する
          this.setInterval(constants.ALLCORRECT_INTERVAL).then(function() {
            self.$emit("endAct");
          });
          return;
        }
        if (this.givenActs.length != 0) {
          this.givenPlaySounds();
        }
        this.showImage = true;
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(nesstatus) {
      this.log("A3 watch lessonState");

      const self = this;

      if (this.lessonState == storeConstants.LESSON_STATE_START) {
        this.givenQuestions();
      } else if (this.lessonState == storeConstants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState == storeConstants.LESSON_STATE_PAUSE) {
        if (this.allCorrectTimer != null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState == storeConstants.LESSON_STATE_RESTART) {
        if (!this.dispAllAnswerStatus && !this.showImage) {
          this.givenPlaySounds();
        }
      }

      if (this.isMobile()) {
        // 表示領域自動調整
        let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
        this.autoAdjustFirstShown(funcs, [".cards-container"]);
        // スクロールアイコン表示
        this.$emit("showScrollIcon", document.getElementsByClassName("cards-container")[0]);
      }
    },
    /**
     * 中国語表示切り替え
     *
     * @param string newstatus
     */
    scriptType: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 表示モード切り替え
     *
     * @param string newstatus
     */
    displayMode: function(newstatus) {
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/card";
</style>
<style lang="scss">
body.propPc #eleCorrect {
  display: none;
}
body.propSp {
  #eleCorrect {
    position: fixed;
    background-size: 60px 60px;
    z-index: 9;
  }
  .a3 {
    .card-inner {
      .item .correct {
        display: none !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// A3.vue?3b6ac59e